"use strict";

exports.__esModule = true;
exports.default = toPath;
var _underscore = _interopRequireDefault(require("./underscore.js"));
var _isArray = _interopRequireDefault(require("./isArray.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Normalize a (deep) property `path` to array.
// Like `_.iteratee`, this function can be customized.
function toPath(path) {
  return (0, _isArray.default)(path) ? path : [path];
}
_underscore.default.toPath = toPath;